module.exports = __webpack_public_path__ + "img/profile_box_coach_position.16c422dc.svg";